import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPhoneDropdownOpen, setIsPhoneDropdownOpen] = useState(false);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);

  const handleNavigation = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
    setIsMenuOpen(false);
    setIsProductDropdownOpen(false);
  };

  const navigationItems = [
    { name: 'ホーム', path: '/' },
    { name: 'ドローン', path: '/drones' },
    { name: '自動操舵', path: '/auto-steering' },
    { name: 'ドローンスクール', path: '/school' },
    { name: '事例紹介', path: '/case-studies' },
    { name: '私たちについて', path: '/about' },
    { name: '拠点一覧', path: '/locations' },
    { name: '水管理', path: '/water-management' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="w-full px-2 sm:px-4 lg:px-6 py-2 sm:py-3">
        <div className="flex items-center justify-between">
          {/* ロゴ */}
          <div className="flex items-center flex-shrink-0 min-w-0">
            <button onClick={() => handleNavigation('/')} className="cursor-pointer">
              <img
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/0fa5f3ef0554dd0c026b275b14f8a7ae.png"
                alt="IDS教習所グループ"
                className="h-5 sm:h-6 md:h-7 lg:h-8 w-auto"
              />
            </button>
          </div>

          {/* デスクトップナビゲーション */}
          <nav className="hidden xl:flex items-center space-x-3 2xl:space-x-6">
            <div className="relative">
              <button
                className="flex items-center space-x-1 text-gray-700 hover:text-[#2A6041] transition-colors whitespace-nowrap cursor-pointer text-xs 2xl:text-sm font-medium"
                onClick={() => setIsProductDropdownOpen(!isProductDropdownOpen)}
              >
                <span>製品から探す</span>
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>

              {/* ドロップダウンメニュー */}
              {isProductDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 2xl:w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                  <div className="py-2">
                    <button
                      onClick={() => handleNavigation('/drones')}
                      className="block w-full text-left px-3 2xl:px-4 py-2 text-xs 2xl:text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    >
                      <div className="font-semibold text-xs 2xl:text-sm">農業ドローン</div>
                      <div className="text-xs text-gray-500 mt-1">散布・防除用ドローン</div>
                    </button>
                    <button
                      onClick={() => handleNavigation('/auto-steering')}
                      className="block w-full text-left px-3 2xl:px-4 py-2 text-xs 2xl:text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    >
                      <div className="font-semibold text-xs 2xl:text-sm">自動操舵システム</div>
                      <div className="text-xs text-gray-500 mt-1">RTK自動操舵システム</div>
                    </button>
                    <button
                      onClick={() => handleNavigation('/water-management')}
                      className="block w-full text-left px-3 2xl:px-4 py-2 text-xs 2xl:text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    >
                      <div className="font-semibold text-xs 2xl:text-sm">水管理システム</div>
                      <div className="text-xs text-gray-500 mt-1">自動給排水システム</div>
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button
              onClick={() => handleNavigation('/school')}
              className="text-gray-700 hover:text-[#2A6041] transition-colors whitespace-nowrap cursor-pointer text-xs 2xl:text-sm font-medium"
            >
              ドローンスクール
            </button>
            <button
              onClick={() => handleNavigation('/maintenance-service')}
              className="text-gray-700 hover:text-[#2A6041] transition-colors whitespace-nowrap cursor-pointer text-xs 2xl:text-sm font-medium"
            >
              点検・整備サービス
            </button>
            <button
              onClick={() => handleNavigation('/about')}
              className="text-gray-700 hover:text-[#2A6041] transition-colors whitespace-nowrap cursor-pointer text-xs 2xl:text-sm font-medium"
            >
              グループ概要
            </button>
            <button
              onClick={() => handleNavigation('/locations')}
              className="text-gray-700 hover:text-[#2A6041] transition-colors whitespace-nowrap cursor-pointer text-xs 2xl:text-sm font-medium"
            >
              拠点一覧
            </button>
          </nav>

          {/* 右側のCTA */}
          <div className="hidden xl:flex items-center space-x-2 2xl:space-x-3">
            <div className="flex flex-col items-end relative hidden 2xl:flex">
              <button
                className="flex items-center text-[#2A6041] font-semibold cursor-pointer text-xs 2xl:text-sm"
                onClick={() => setIsPhoneDropdownOpen(!isPhoneDropdownOpen)}
              >
                <i className="ri-phone-line mr-1 text-sm"></i>
                <span>お電話でのご相談</span>
                <i className="ri-arrow-down-s-line ml-1 text-xs"></i>
              </button>
              <span className="text-xs text-gray-600 mt-1">平日9:00-17:00</span>

              {isPhoneDropdownOpen && (
                <div className="absolute top-full right-0 mt-2 w-60 bg-white shadow-lg rounded-lg border z-50">
                  <div className="py-2">
                    <div className="px-4 py-2 text-sm font-semibold text-gray-700 border-b">
                      各拠点へのお電話
                    </div>
                    <a href="tel:0952-71-9855" className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-50 cursor-pointer">
                      <div className="font-semibold text-xs">IDS佐賀教習所</div>
                      <div className="text-xs text-gray-500 mt-1">（株式会社アイテム）</div>
                      <div className="text-[#2A6041] font-bold text-sm mt-1">0952-71-9855</div>
                    </a>
                    <a href="tel:0952-97-5291" className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-50 cursor-pointer">
                      <div className="font-semibold text-xs">IDS川副教習所</div>
                      <div className="text-xs text-gray-500 mt-1">（九三エンジニアリング株式会社）</div>
                      <div className="text-[#2A6041] font-bold text-sm mt-1">0952-97-5291</div>
                    </a>
                    <a href="tel:099-213-9466" className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-50 cursor-pointer">
                      <div className="font-semibold text-xs">IDS鹿児島教習所</div>
                      <div className="text-xs text-gray-500 mt-1">（株式会社エコナーセリー）</div>
                      <div className="text-[#2A6041] font-bold text-sm mt-1">099-213-9466</div>
                    </a>
                  </div>
                </div>
              )}
            </div>

            <button
              className="px-2 py-1 xl:px-3 xl:py-2 2xl:px-4 2xl:py-2 bg-[#FFC107] text-black rounded-lg hover:bg-yellow-500 transition-colors whitespace-nowrap cursor-pointer font-bold text-xs 2xl:text-sm"
              onClick={() => {
                const ctaSection = document.querySelector('[data-cta-section]');
                if (ctaSection) {
                  ctaSection.scrollIntoView({ behavior: 'smooth' });
                } else {
                  // CTAセクションが見つからない場合はホームページに移動してからスクロール
                  if (window.REACT_APP_NAVIGATE) {
                    window.REACT_APP_NAVIGATE('/');
                    setTimeout(() => {
                      const homeCtaSection = document.querySelector('[data-cta-section]');
                      if (homeCtaSection) {
                        homeCtaSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }
                }
              }}
            >
              お見積り・無料相談
            </button>
          </div>

          {/* モバイルメニューボタン */}
          <button
            className="xl:hidden flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`text-xl sm:text-2xl text-gray-700 ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="xl:hidden mt-3 sm:mt-4 pb-3 sm:pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-3 sm:space-y-4 pt-3 sm:pt-4">
              <div>
                <button
                  className="w-full text-left text-gray-700 hover:text-[#2A6041] transition-colors cursor-pointer text-base sm:text-lg py-2 sm:py-3 flex items-center justify-between font-medium"
                  onClick={() => setIsProductDropdownOpen(!isProductDropdownOpen)}
                >
                  <span>製品から探す</span>
                  <i className={`ri-arrow-down-s-line transition-transform text-base sm:text-lg ${isProductDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isProductDropdownOpen && (
                  <div className="ml-3 sm:ml-4 mt-2 sm:mt-3 space-y-2 sm:space-y-3">
                    <button onClick={() => handleNavigation('/drones')} className="block text-gray-600 hover:text-[#2A6041] transition-colors cursor-pointer text-sm sm:text-base py-1 sm:py-2 font-medium">
                      農業ドローン
                    </button>
                    <button onClick={() => handleNavigation('/auto-steering')} className="block text-gray-600 hover:text-[#2A6041] transition-colors cursor-pointer text-sm sm:text-base py-1 sm:py-2 font-medium">
                      自動操舵システム
                    </button>
                    <button onClick={() => handleNavigation('/water-management')} className="block text-gray-600 hover:text-[#2A6041] transition-colors cursor-pointer text-sm sm:text-base py-1 sm:py-2 font-medium">
                      水管理システム
                    </button>
                  </div>
                )}
              </div>
              <button onClick={() => handleNavigation('/school')} className="text-gray-700 hover:text-[#2A6041] transition-colors cursor-pointer text-base sm:text-lg py-2 sm:py-3 text-left font-medium">
                ドローンスクール
              </button>
              <button onClick={() => handleNavigation('/maintenance-service')} className="text-gray-700 hover:text-[#2A6041] transition-colors cursor-pointer text-base sm:text-lg py-2 sm:py-3 text-left font-medium">
                点検・整備サービス
              </button>
              <button onClick={() => handleNavigation('/about')} className="text-gray-700 hover:text-[#2A6041] transition-colors cursor-pointer text-base sm:text-lg py-2 sm:py-3 text-left font-medium">
                グループ概要
              </button>
              <button onClick={() => handleNavigation('/locations')} className="text-gray-700 hover:text-[#2A6041] transition-colors cursor-pointer text-base sm:text-lg py-2 sm:py-3 text-left font-medium">
                拠点一覧
              </button>

              <div className="pt-3 sm:pt-4 space-y-3 sm:space-y-4">
                <button
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 bg-[#FFC107] text-black rounded-lg hover:bg-yellow-500 transition-colors cursor-pointer font-bold text-base sm:text-lg"
                  onClick={() => {
                    const ctaSection = document.querySelector('[data-cta-section]');
                    if (ctaSection) {
                      ctaSection.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      // CTAセクションが見つからない場合はホームページに移動してからスクロール
                      if (window.REACT_APP_NAVIGATE) {
                        window.REACT_APP_NAVIGATE('/');
                        setTimeout(() => {
                          const homeCtaSection = document.querySelector('[data-cta-section]');
                          if (homeCtaSection) {
                            homeCtaSection.scrollIntoView({ behavior: 'smooth' });
                          }
                        }, 100);
                      }
                    }
                    setIsMenuOpen(false);
                  }}
                >
                  お見積り・無料相談
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
